import { AlarmFilter } from "../../services";
import monitorBloc from "../../services/bloc";
import { Vue } from 'vue-class-component';
import moment from "moment";


export abstract class AlarmFilterComponent extends Vue {
    monitorBloc = monitorBloc;
    alarmFilter = new AlarmFilter;
    levels = [
        {
            label: 'Normal',
            value: 1,
        },
        {
            label: 'Warning',
            value: 77,
        },
        {
            label: 'Critical',
            value: 78,
        },
    ];
    levelOptions: any[] = [];
    levelLoading = false;
    startDatetime = null;
    endDatetime = null;
    isLoading = false;

    searching() {
        this.$emit("filter", this.alarmFilter);
    }

    reset() {
        this.alarmFilter = new AlarmFilter;
        this.startDatetime = null;
        this.endDatetime = null;
        this.$emit("filter", this.alarmFilter);
    }

    startDateDisabled(ts: number) {
        const date = new Date(ts);
        return moment().isBefore(date, 'day');
    }

    startTimeDisabled(ts: number) {
        const date = new Date(ts);
        return {
            isHourDisabled: (hour: number) => {
                if (!moment().isSame(date, 'day')) return false;
                return hour > new Date().getHours();
            },
            isMinuteDisabled: (minute: number, hour: number | null) => {
                if (hour === null) return false;
                if (!moment().isSame(date, 'day')) return false;
                return minute > new Date().getMinutes();
            },
        }
    }

    endDateDisabled(ts: number) {
        const date = new Date(ts);
        if (moment().isBefore(date, 'day')) return true;
        return moment(this.alarmFilter.start_date).isAfter(date, 'day');
    }

    endTimeDisabled(ts: number) {
        const date = new Date(ts);
        return {
            isHourDisabled: (hour: number) => {
                if (moment().isSame(date, 'day') && hour > new Date().getHours()) return true;
                if (moment(this.alarmFilter.start_date).isBefore(date, 'day')) return false;
                return hour < new Date(this.alarmFilter.start_date).getHours();
            },
            isMinuteDisabled: (minute: number, hour: number | null) => {
                if (hour === null) return false;
                if (moment().isSame(date, 'day') && minute > new Date().getMinutes()) return true;
                if (moment(this.alarmFilter.start_date).isBefore(date, 'day')) return false;
                return minute <= new Date(this.alarmFilter.start_date).getMinutes();
            },
        }
    }

    onStartChanged() {
        this.alarmFilter.start_date = moment(this.startDatetime ?? '').format('YYYY-MM-DD');

        const initial = new AlarmFilter;
        this.alarmFilter.end_date = initial.end_date;
        this.endDatetime = null;
    }

    onEndChanged() {
        this.alarmFilter.end_date = moment(this.endDatetime ?? '').format('YYYY-MM-DD');
    }

    async onEquipmentSearch(query: string) { }

    async onTypeSearch(query: string) { }

    async onLevelSearch(query: string) { }
}